import React from "react";
import BlogCard from "../BlogCard/BlogCard";
import "./Blog.css";

const posts = [
  {
    userId: 1,
    id: 1,
    title: "All you need to know about React",
    body: "I have been using React for over a year now. So now decide to write a post about all experience I gathered in the fields of React. The essential guide is for beginners only there I covered the basic concepts as fundamentals for working with React. It is not a complete guide to React but rather a complete introduction",
    blogURL:
      "https://showkatjubayer.medium.com/all-you-need-to-know-about-react-5e03f764238",
  },
  {
    userId: 1,
    id: 2,
    title: "JavaScript, 10 Basic String Methods are Simplified",
    body: "JavaScript string is a simple text. To create a string in javascript you have to write some characters inside quotes. JavaScript strings are used for storing and manipulating text. In JavaScript you can use different method to change text behaviour in the sentence of a passage",
    blogURL:
      "https://medium.com/@showkatjubayer/10-basic-string-methods-in-javascript-are-simplified-for-you-273f0eab8fc0",
  },
  {
    userId: 1,
    id: 3,
    title: "Things you should know as a JavaScript Developer",
    body: "So, It’s very easy to get started with JavaScript but it’s quite hard to be a master of it. JavaScript keeps a website alive. Basically, it’s used for frontend development but nowadays it is used in the backend too. Its become a more powerful programming language over the era",
    blogURL:
      "https://showkatjubayer.medium.com/things-you-should-know-as-a-javascript-developer-4b9ed639da4c",
  },
  // {
  //   userId: 1,
  //   id: 4,
  //   title: "Essential JavaScript Interview Questions and Answers",
  //   body: "JavaScript is the most misunderstood programming language. So it’s become tough when you talk about it. So, I had face interviews about JavaScript sometimes. Now I’m going to share my experience and most essential JavaScript Interview Questions and Answers",
  //   blogURL:
  //     "https://showkatjubayer.medium.com/10-essential-javascript-interview-questions-and-answers-b8fde88307c0",
  // },
  // {
  //     "userId": 1,
  //     "id": 5,
  //     "title": "nesciunt quas odio",
  //     "body": "repudiandae veniam quaerat sunt sed\nalias aut fugiat sit autem sed est\nvoluptatem omnis possimus esse voluptatibus quis\nest aut tenetur dolor neque",
  //     "blogURL": "#"
  // },
  // {
  //     "userId": 1,
  //     "id": 6,
  //     "title": "dolorem eum magni eos aperiam quia",
  //     "body": "ut aspernatur corporis harum nihil quis provident sequi\nmollitia nobis aliquid molestiae\nperspiciatis et ea nemo ab reprehenderit accusantium quas\nvoluptate dolores velit et doloremque molestiae",
  //     "blogURL": "#"
  // }
];

const Blog = () => {
  // const [posts, setPosts] = useState([])
  // useEffect(() => {
  //     fetch('http://jsonplaceholder.typicode.com/posts')
  //         .then(res => res.json())
  //         .then(data => setPosts(data.slice(0, 6)))
  // }, [])
  return (
    <div className="blog-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2 className="pb-5">Some of My Articles</h2>
          </div>
        </div>
        <div className="row">
          <div className="blog-posts">
            {posts.map((post) => (
              <BlogCard key={post.id} post={post}></BlogCard>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
